export enum articlesDeleteTypes {
  FETCH_ARTICLES_DELETE_REQUEST = "FETCH_ARTICLES_DELETE_REQUEST",
  FETCH_ARTICLES_DELETE_SUCCESS = "FETCH_ARTICLES_DELETE_SUCCESS",
  FETCH_ARTICLES_DELETE_FAILURE = "FETCH_ARTICLES_DELETE_FAILURE",
}